export default "__VITE_ASSET__DWguvjja__"